import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(100, 100, 100);
  > h1 {
    color: #ffffff;
    font-weight: bold;
  }

  > svg {
    color: red;
  }
`;
